import React from "react";

import edit_user from "./edit_user.png";

const EditingAndUpdatingUsers = () => (
  <div id="admin_edit_user" className="section">
    <h2>3.3 Edit User</h2>
    <p>
      By clicking on a particular row on the list of users you can edit the user's name, email
      address, reset their password and extend a time limit, if a time limit was put in place and
      has expired.
    </p>
    <p>
      <strong>Extra Courses</strong>
    </p>
    <p>
      Extra courses can also be assigned via the edit user option (if available). Select the person
      you wish to assign an extra course to by clicking the row on the List Users page. On the Edit
      User page assign extra courses by placing a tick in the relevant tick box, then click
      update... This way the user can continue with their existing login information and gain access
      to multiple courses.
    </p>
    <img src={edit_user} alt="Edit User" className="center" />
  </div>
);

export default EditingAndUpdatingUsers;
